import { createMachine } from 'xstate';

import {
  PaginationMachineEvents,
  PaginationMachineId,
  PaginationMachineStates
} from './constants';
import { FormsMachineEventsType, PaginationMachineContext } from './types';

const { setCurrentPageNo, getPaginationData } = PaginationMachineEvents;

const { initializePaginationMachineState, getPaginationDataState } =
  PaginationMachineStates;

export const paginationMachine = () =>
  createMachine<PaginationMachineContext, FormsMachineEventsType>({
    id: PaginationMachineId,
    initial: initializePaginationMachineState,
    context: {
      apiURL: '',
      data: {},
      errorMessage: '',
      totalPageNo: 0,
      currentPageNo: 0,
      eachPageLimit: 10,
      isDataFetching: false
    },
    on: {
      [setCurrentPageNo]: {
        actions: ['setCurrentPageNumber']
      },
      [getPaginationData]: {
        target: getPaginationDataState
      }
    },
    states: {
      [initializePaginationMachineState]: {
        entry: ['initializePaginationMachine'],
        on: {
          '': getPaginationDataState
        }
      },
      [getPaginationDataState]: {
        entry: ['setIsDataFetchingTrue'],
        invoke: {
          src: 'fetchPredictedCollegesData',
          onDone: {
            actions: ['setPaginationData', 'setIsDataFetchingFalse']
          },
          onError: {
            actions: ['setIsDataFetchingFalse']
          }
        }
      }
    }
  });
